import React, { useEffect, useState, useCallback } from 'react'
import { getUserDetails, UpdateUserDetails } from '../../services/authService'
import { UserProfileUpdate } from '../../types/user';
import { useLoader } from '../../provider/LoaderProvider';
import toast, { Toaster } from "react-hot-toast";

const EditProfile = () => {
  const [userDetails, setUserDetails] = useState<UserProfileUpdate | null>(null);
  const [formData, setFormData] = useState<UserProfileUpdate | null>(null);

  const { setLoading } = useLoader();

  const fetchUserDetails = useCallback(async () => {
    setLoading(true);
    try {
      const fetchedUserDetails = await getUserDetails();
      console.log(fetchedUserDetails); // Log the fetched data
      if (fetchedUserDetails) {
        setUserDetails(fetchedUserDetails); // Save the fetched data
        setFormData(fetchedUserDetails); // Prepopulate the form
      }
    } catch (error) {
      console.log("Error fetching user details", error);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);
  // Handle form field changes
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState!,
      [name]: value,
    }));
  };
  const handleCancel = () => {
  setFormData(userDetails); 
  toast("Changes reverted", { icon: "↩️" });
};

  // Handle form submission (update user profile)
  const handleSubmit = async (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();
    if (formData) {
      // You can add a function here to send the updated data to the server
      console.log("Form data to be updated:", formData);
      const result = await UpdateUserDetails(formData);

    if (result) {
        toast.success("Profile updated successfully!");
        fetchUserDetails();
    } else {
        toast.error("Something went wrong.");
    }


    setLoading(false);
      
      // Example: await updateUserDetails(formData);
    }
  };


  if (!formData) {
    return <div>No user data available</div>;
  }

  return (
    <>
    <Toaster />
    <div className="flex flex-col p-6 mx-auto mt-20 max-w-4xl min-h-0 bg-white rounded-lg shadow-md">
      <h2 className="mb-6 text-2xl font-bold text-gray-800">Edit Profile</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* First Name */}
          <div>
            <label htmlFor="fullName" className="block text-sm font-medium text-gray-700">
              Full Name
            </label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          {/* Last Name */}
          <div>
            <label htmlFor="Name" className="block text-sm font-medium text-gray-700">
              Name
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>

        {/* Email */}
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">
            Email
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Phone */}
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
              Phone
            </label>
            <input
              type="text"
              id="phone"
              name="phone"
              value={formData.contactNo}
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          {/* Date of Birth */}
          <div>
            <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700">
              Date of Birth
            </label>
            <input
              type="date"
              id="dateOfBirth"
              name="dateOfBirth"
              //   value={formData.dateOfBirth}
              value={formData.dateOfBirth ? new Date(formData.dateOfBirth).toLocaleDateString("en-CA") : ''} // Convert string to 'YYYY-MM-DD'
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>

        {/* Address Fields */}
        <div>
          <label htmlFor="addressLine1" className="block text-sm font-medium text-gray-700">
            Institute
          </label>
          <input
            type="text"
            id="institute"
            name="institute"
            value={formData.institute}
            onChange={handleChange}
            className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* City */}
          <div>
            <label htmlFor="city" className="block text-sm font-medium text-gray-700">
              City
            </label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          {/* State */}
          <div>
            <label htmlFor="state" className="block text-sm font-medium text-gray-700">
              State
            </label>
            <input
              type="text"
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* City */}
          <div>
            <label htmlFor="hobbies" className="block text-sm font-medium text-gray-700">
              Hobbies
            </label>
            <input
              type="text"
              id="hobbies"
              name="hobbies"
              value={formData.hobbies}
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          {/* State */}
          <div>
            <label htmlFor="dreamCareerOptions" className="block text-sm font-medium text-gray-700">
              Dream Career Options
            </label>
            <input
              type="text"
              id="dreamCareerOptions"
              name="dreamCareerOptions"
              value={formData.dreamCareerOptions}
              onChange={handleChange}
              className="block mt-1 w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>
        </div>
        {/* Buttons */}
        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={handleCancel}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-md border border-gray-300 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md border border-transparent shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Update Profile
          </button>
        </div>
      </form>
    </div>
    </>
  );
};

export default EditProfile;